// src/pages/LoginPage.jsx
import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import LoginButtons from "../components/LoginButtons";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const { login, user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const handleEmailLogin = () => {
    if (!email) return alert("Please enter an email.");

    login({
      name: email.split("@")[0],
      email,
      method: "Email"
    });

    navigate("/order");
  };

  if (user)
    return (
      <div className="login-page">
        <h2>Welcome, {user.name}!</h2>
        <p>Signed in via {user.method}</p>

        <button className="logout-btn" onClick={logout}>
          Logout
        </button>
      </div>
    );

  return (
    <div className="login-page">
      <h1>Login</h1>

      {/* Email Login */}
      <div className="email-login">
        <input
          type="email"
          placeholder="Enter your email"
          className="email-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button className="email-btn" onClick={handleEmailLogin}>
          Continue with Email
        </button>
      </div>

      <p className="or-text">OR</p>

      <LoginButtons />
    </div>
  );
}
